import React, { Suspense, useContext, useState, useEffect } from 'react';
import { initReactI18next } from 'react-i18next';
import environment from '@ktag/styleguide/src/javascripts/environment/environment';
import analytics from '@ktag/styleguide/src/javascripts/analytics/analytics';
import { i18n } from '@ktag/styleguide/dist/base';
import { Pagesection, Contentcol, Header, Footer, PageWrapper } from '@ktag/styleguide/dist/react';

import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';

import {
  FormConfigStore,
  MunicipalityStore,
  PaymentStore,
  SVCConfigStore,
  ArticlesStore,
  initService,
  AppOrderFinal,
} from 'ewp-common';

import { Placeholder } from './components/yourcomponent/react/Yourcomponent';
import ReputationcertForm from './components/reputationcertForm/react/ReputationcertForm';
import FormDataStore from './stores/formDataStore';
import environmentConfig from './config/environment';
import defaultFooterConfig from 'config/footer-config';
import './app.scss';

interface Props {
  standalone: boolean;
  apiUrl: string;
  translationApiUrl: string | null;
  translationMissingApiUrl: string | null;
}

interface I18nProjectConfig {
  backend?: { loadPath: string, addPath?: string };
  saveMissing?: boolean;
}



function AppRoutes() {
  return (
    <Router basename="reputationcert">
    <Switch>
      <Route path="/">
        <ReputationcertForm />
      </Route>
      <Route path="/orderfinal">
        <AppOrderFinal />
      </Route>
    </Switch>
  </Router>
  );
}

function AppContexts(props) {
  return (
    <Suspense fallback={<Placeholder />}>
      <SVCConfigStore.SVCConfigContextProvider>
        <MunicipalityStore.MunicipalityContextProvider>
          <FormConfigStore.FormConfigContextProvider>
            <FormDataStore.FormDataContextProvider>
              <PaymentStore.PaymentContextProvider>
                <ArticlesStore.ArticlesContextProvider>
                {props.children}
                </ArticlesStore.ArticlesContextProvider>
              </PaymentStore.PaymentContextProvider>
            </FormDataStore.FormDataContextProvider>
          </FormConfigStore.FormConfigContextProvider>
        </MunicipalityStore.MunicipalityContextProvider>
      </SVCConfigStore.SVCConfigContextProvider>
    </Suspense>
  );
}

function DevAppView() {

  const [footerConfig, updateFooterConfig] = useState(defaultFooterConfig);

  const {
    state: municipalityState,
  } = useContext(MunicipalityStore.MunicipalityContext);

  useEffect(() => {
    const footerDetails = municipalityState?.selectedMunicipality?.data?.footerDetails;
    if(footerDetails) {
      updateFooterConfig({
        ...footerConfig,
        config: footerDetails
      });
    }
  }, [municipalityState?.selectedMunicipality?.data?.footerDetails])

  return (
    <PageWrapper>
      <Header />
      <PageWrapper.Main>
        {/* <Pagesection> */}
          <Contentcol aside>
            <AppRoutes />
          </Contentcol>
        {/* </Pagesection> */}
      </PageWrapper.Main>
      <Footer {...footerConfig} />
    </PageWrapper>
  );
}

function App(props: Props) {
  const {
    standalone,
    translationApiUrl,
    translationMissingApiUrl,
  } = props;

  // Initialize the environment/analytics with the web-config from @ktag/styleguide
  // if you do NOT pass an environmentConfig, the app will try to use the environment
  // config of the 'surrounding' environment, if it is e.g. embedded in www.ag.ch
  environment.initialize(environmentConfig);
  analytics.initialize();

  initService.configure({
    enviromnent: environmentConfig,
  });
  // initialize i18n either with local translation files or
  // if available from the translation api
  const i18nProjectConfig: I18nProjectConfig = {};
  if (translationApiUrl) {
    i18nProjectConfig.backend = { loadPath: translationApiUrl };
    if (translationMissingApiUrl) {
      i18nProjectConfig.saveMissing = true;
      i18nProjectConfig.backend.addPath = translationMissingApiUrl;
    }
  }
  i18n.initialize(i18nProjectConfig, { plugin: initReactI18next });

  // Production view.
  // Nothing but the actual app is rendered.
  if (standalone !== true) {
    return (
      <AppContexts>
        <AppRoutes />
      </AppContexts>
    );
  }

  // Develop and debug view
  // A complete web view is rendered around the app including
  // the loading of all necessary resources (css, images, fonts, icons, ...)
  return (
    // <BoilerplateWeb siteName={`${process.env.REACT_APP_NAME} v${process.env.REACT_APP_VERSION}`}>
      <AppContexts>
      <DevAppView />
    </AppContexts>
    //   <PageWrapper>
    //   <Header />
    //   <PageWrapper.Main>
    //     {/* <Pagesection> */}
    //       <Contentcol aside>
    //         <AppContexts />
    //       </Contentcol>
    //     {/* </Pagesection> */}
    //   </PageWrapper.Main>
    //   {/* <Footer {...footerConfigs} /> */}
    // </PageWrapper>
    // </BoilerplateWeb>
  );
}

App.defaultProps = {
  standalone: false,
  apiUrl: '',
  translationApiUrl: null,
  translationMissingApiUrl: null,
};

export default App;
